import { DateRangeValue } from '../../../components/DateRangePicker/DateRangePicker'

/**
 * Resolves the initial performance chart date range so that it shows data. If the given
 * default range already contains revenue/downloads estimates, it is returned unchanged.
 * Otherwise the range is snapped to the nearest year that has data, i.e. one year ending
 * at the latest estimate with a non-zero revenue or downloads value. (GR-1326)
 */
export const resolveNearestDataYearDateRange = (
  estimates: { ts: number; revenue?: number; downloads?: number }[],
  range: DateRangeValue | undefined
): DateRangeValue | undefined => {
  if (!range?.fromDate || !range?.toDate) {
    return range
  }

  const estimatesWithData = estimates.filter((estimate) => (estimate.revenue || 0) > 0 || (estimate.downloads || 0) > 0)
  if (estimatesWithData.length === 0) {
    return range
  }

  const fromTs = range.fromDate.getTime()
  const toTs = range.toDate.getTime()
  const hasDataWithinRange = estimatesWithData.some((estimate) => estimate.ts >= fromTs && estimate.ts <= toTs)
  if (hasDataWithinRange) {
    return range
  }

  const lastDataTs = Math.max(...estimatesWithData.map((estimate) => estimate.ts))
  const toDate = new Date(new Date(lastDataTs).setHours(0, 0, 0, 0))
  const fromDate = new Date(new Date(new Date(toDate).setFullYear(toDate.getFullYear() - 1)).setHours(0, 0, 0, 0))

  return { fromDate, toDate }
}
